import { render, staticRenderFns } from "./UnitOfMeasuresRegistryEditForm.vue?vue&type=template&id=63c6457e"
import script from "./UnitOfMeasuresRegistryEditForm.vue?vue&type=script&lang=js"
export * from "./UnitOfMeasuresRegistryEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports